import axios from 'axios'
import { RootState, store } from '../store/reducers/store'
import { refreshToken, unauthenticate } from '../store/actions/authentication'

const CustomAxios = axios.create()

// const toCamelCase: any = (object: any) => {
//     let transformedObject = object
//     if (typeof object === 'object' && object !== null) {
//         if (object instanceof Array) {
//             transformedObject = object.map(toCamelCase)
//         } else {
//             transformedObject = {}
//             for (const key in object) {
//                 if (object[key] !== undefined) {
//                     const newKey = key.replace(/(_\w)|(-\w)/g, (k) => k[1].toUpperCase())
//                     transformedObject[newKey] = toCamelCase(object[key])
//                 }
//             }
//         }
//     }
//     return transformedObject
// }

// export const toSnackCase: any = (object: any) => {
//     let transformedObject = object
//     if (typeof object === 'object' && object !== null) {
//         if (object instanceof Array) {
//             transformedObject = object.map(toSnackCase)
//         } else {
//             transformedObject = {}
//             for (const key in object) {
//                 if (object[key] !== undefined) {
//                     const newKey = key
//                         .replace(/\.?([A-Z]+)/g, function (_, y) {
//                             return '_' + y.toLowerCase()
//                         })
//                         .replace(/^_/, '')
//                     transformedObject[newKey] = toSnackCase(object[key])
//                 }
//             }
//         }
//     }
//     return transformedObject
// }

CustomAxios.interceptors.response.use(
    (response) => {
        return response
    },
    async (error) => {
        const originalRequest = error.config;
        if ((error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
            originalRequest._retry = true;
            await store.dispatch(refreshToken());
            const state = store.getState() as RootState;
            const access_token = state.authentication.token;
            originalRequest.headers['Authorization'] = 'Bearer ' + access_token;
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
            return CustomAxios(originalRequest);
        } else if ((error.response.status === 401 || error.response.status === 403) && originalRequest._retry) {
            await store.dispatch(unauthenticate());
        }
        return error
    },
)

CustomAxios.interceptors.request.use(
    (config) => {
        const state = store.getState() as RootState;
        const access_token = state.authentication.token;
        if (config.headers['Authorization'] === undefined && access_token) {
            config.headers['Authorization'] = 'Bearer ' + access_token;
        }
        return config;
    }
)

export default CustomAxios
